<template>
  <div>
    <base-header class="pb-6"></base-header>
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header border-0">
          <h3 class="mb-0">{{ copy.title }}</h3>
          <p v-if="kitchenName" class="text-sm text-muted mb-0">{{ kitchenName }}</p>
        </div>

        <div v-if="isLoading" class="card-body text-center text-muted py-5">{{ copy.states.loading }}</div>
        <div v-else-if="failureMessage" class="card-body">
          <div class="kc-alert" role="alert">
            <span>{{ failureMessage }}</span>
            <base-button v-if="canRetry" size="sm" type="secondary" @click="loadCharges">{{ copy.states.retry }}</base-button>
          </div>
        </div>
        <template v-else-if="report">
          <div v-if="!entries.length" class="card-body text-muted">{{ copy.states.empty }}</div>
          <kitchen-charges-table v-else :entries="entries" :currency="report.currency" @select="openEntry" />
        </template>
      </div>
    </div>
    <kitchen-charge-detail-dialog
      v-if="report"
      :entry="selectedEntry"
      :currency="report.currency"
      :visible="isDetailOpen"
      @close="closeEntry"
    />
  </div>
</template>

<script>
import PackagingChargesGateway, {
  CHARGES_NOT_AVAILABLE_CODE,
  MISSING_SESSION_CODE,
} from '@/gateways/PackagingChargesGateway';
import { KITCHEN_CHARGES_COPY } from '@/components/KitchenCharges/copy';
import KitchenChargesTable from '@/components/KitchenCharges/KitchenChargesTable.vue';
import KitchenChargeDetailDialog from '@/components/KitchenCharges/KitchenChargeDetailDialog.vue';

const SESSION_FAILURE = 'session';
const NOT_AVAILABLE_FAILURE = 'notAvailable';
const REQUEST_FAILURE = 'request';
const FAILURE_BY_CODE = Object.freeze({
  [MISSING_SESSION_CODE]: SESSION_FAILURE,
  [CHARGES_NOT_AVAILABLE_CODE]: NOT_AVAILABLE_FAILURE,
});
const FAILURE_MESSAGES = Object.freeze({
  [SESSION_FAILURE]: KITCHEN_CHARGES_COPY.states.missingSession,
  [NOT_AVAILABLE_FAILURE]: KITCHEN_CHARGES_COPY.states.notAvailable,
  [REQUEST_FAILURE]: KITCHEN_CHARGES_COPY.states.failed,
});

export default {
  name: 'KitchenChargesPage',
  components: {
    KitchenChargesTable,
    KitchenChargeDetailDialog,
  },
  data() {
    return {
      copy: KITCHEN_CHARGES_COPY,
      report: null,
      isLoading: false,
      failure: null,
      selectedEntry: null,
      isDetailOpen: false,
    };
  },
  computed: {
    entries() {
      return this.report && Array.isArray(this.report.entries) ? this.report.entries : [];
    },
    kitchenName() {
      return this.report && this.report.kitchen ? this.report.kitchen.name : '';
    },
    failureMessage() {
      return this.failure ? FAILURE_MESSAGES[this.failure] : '';
    },
    canRetry() {
      return this.failure !== NOT_AVAILABLE_FAILURE;
    },
  },
  created() {
    this.loadCharges();
  },
  methods: {
    async loadCharges() {
      this.isLoading = true;
      this.failure = null;
      try {
        this.report = await PackagingChargesGateway.fetchCharges();
      } catch (loadError) {
        this.failure = FAILURE_BY_CODE[loadError.code] || REQUEST_FAILURE;
      } finally {
        this.isLoading = false;
      }
    },
    openEntry(entry) {
      this.selectedEntry = entry;
      this.isDetailOpen = true;
    },
    closeEntry() {
      this.isDetailOpen = false;
    },
  },
};
</script>

<style scoped>
.kc-alert {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 12px;
  border-radius: 0.375rem;
  padding: 12px 16px;
  font-size: 0.875rem;
  background: #fef2f2;
  color: #b91c1c;
  border-left: 3px solid #b91c1c;
}
</style>
